import React, { useState, useRef, useEffect, useMemo } from "react";

import CameraBackground from "../../components/CameraBackground";
import ActivateCameraInfo from "./ActivateCameraInfo";
import ExteriorSceneThreeJS from "./ExteriorSceneThreeJS";
import OverlayScreen from "../../components/OverlayScreen";
import TapToPlace from "./TapToPlace";
// import Gyroscope from "../../components/Gyroscope";
import LandingPageExt from "../../components/LandingPageExt";
// import AnimationButtons from "./AnimationButtons";
import VisitSiteButton from "../../components/VisitSiteButton";
import FlightButton from "../../components/FlightButton";
import LandingDesktopQR from "../../components/LandingDesktopQR";
import useIsDesktop from "../../hooks/useIsDesktop";
import useResourcePreloader from "../../hooks/useResourcePreloader";
import { EXTERIOR_RESOURCES } from '../../assetsDictionary';
import { EXT_STATE } from '../../states';


export default function ExteriorScene() {
  useEffect(() => {
    console.log('[LOG] Index MOUNT');
    return () => {
      console.log('[LOG] Index UNMOUNT');
    };
  }, []);

  const isDesktop = useIsDesktop();

  // Preloader - memorizar el array de recursos para evitar re-renders innecesarios
  const exteriorResources = useMemo(() => {
    const values = Object.values(EXTERIOR_RESOURCES);
    return values;
  }, []);
  const { progress, isComplete } = useResourcePreloader(exteriorResources);

  const [showExperience, setShowExperience] = useState(false);
  const [open, setOpen] = React.useState(true);
  const [shouldFadeOut, setShouldFadeOut] = useState(false);
  const [shouldFadeIn, setShouldFadeIn] = useState(false);

  // Tiempo mínimo de visualización del overlay: 3000ms
  const startTimeRef = useRef(Date.now());
  const hasClosedOverlayRef = useRef(false);
  const MIN_DISPLAY_TIME = 3000;

  // Esperar a que los recursos estén cargados Y que hayan pasado al menos MIN_DISPLAY_TIME ms
  const [flightState, setFlightState] = useState(EXT_STATE.NOT_STARTED);

  useEffect(() => {
    if (isComplete && !hasClosedOverlayRef.current) {
      hasClosedOverlayRef.current = true;
      const elapsed = Date.now() - startTimeRef.current;
      const remainingTime = Math.max(0, MIN_DISPLAY_TIME - elapsed);
      
      const timer = setTimeout(() => {
          setShouldFadeOut(true);
          setOpen(false);
          setShouldFadeIn(true);
      }, remainingTime);

      return () => clearTimeout(timer);
    }
  }, [isComplete]);



    const [playing, setPlaying] = useState(false);
    // tap to place
    const [placed, setPlaced] = useState(false);

    // const [gyroEnabled, setGyroEnabled] = useState(false);

    const [showCamera, setShowCamera] = useState(false);

        useEffect(() => {
    console.log('[LOG] showExperience:', showExperience, 'showCamera:', showCamera);
  }, [showExperience, showCamera]);

    const heliRef = useRef(null);

    const [heliReady, setHeliReady] = useState(false);
    const [isSceneLoaded, setIsSceneLoaded] = useState(false);
    
    // Secuencia de estados deseada
    const STATE_SEQUENCE = [
      EXT_STATE.NOT_STARTED,
      EXT_STATE.FLY_APPROACHING,
      EXT_STATE.FLY_IDLE,
      EXT_STATE.FLY_LANDING,
      EXT_STATE.LANDED,
      EXT_STATE.FLY_LEAVING,
      EXT_STATE.PARTNERSHIP
    ];
    useEffect(() => {
      const heli = heliRef.current;
      if (!heli) return;
      switch (flightState) {
        case EXT_STATE.NOT_STARTED:
          break;
        case EXT_STATE.FLY_APPROACHING:
            heli.playIntro();
          break;
        case EXT_STATE.FLY_IDLE:
          break;
        case EXT_STATE.FLY_LANDING:
          heli.playLand();
          break;
        case EXT_STATE.LANDED:
          // heli.stop?.();
          break;
        case EXT_STATE.FLY_LEAVING:
          heli.playTakeoff();
          break;
        case EXT_STATE.PARTNERSHIP:
          // heli.partnership?.();
          break;
        default:
          break;
      }
    }, [flightState]);

    function advanceFlightState() {
      setFlightState(prev => {
        const idx = STATE_SEQUENCE.indexOf(prev);
        if (idx < STATE_SEQUENCE.length - 1) {
          return STATE_SEQUENCE[idx + 1];
        }
        //si no hay mas State siguientes, vuelvo a STATE 1 => FLY_APPROACHING
        // para que no se quede en el estado final y se pueda volver a empezar
        return STATE_SEQUENCE[1];
      });
    }

    const handleFlightButtonClick = () => {
      advanceFlightState();
    };

    const handleEnterExperience = () => {
        // Solo permitir entrar si los recursos están cargados
        if (!isComplete) return;
        setIsSceneLoaded(false);
        setShowExperience(true);
        handleEnableCamera(true);
    };

    const handleEnableCamera = () => {
        setOpen(true)
        // setGyroEnabled(true);
        // Acá simplemente mostramos la cámara.
        // Si CameraBackground adentro pide permisos, se van a disparar ahora.
        setTimeout(() => {
          setShowCamera(true);
          setPlaced(true);
          // setPlaying(true);
        }, 750);
        setTimeout(() => {

          setOpen(false);
        }, 2000);
    };

    const handleSetPlace = async () => {
        if (!isSceneLoaded || !heliRef.current) return;
        advanceFlightState();
        setPlaced(false)
        setOpen(false)
    };

    const canShowFlightButton =
      flightState === EXT_STATE.FLY_IDLE ||
      flightState === EXT_STATE.LANDED ||
      flightState === EXT_STATE.TAKEOFF ||
      flightState === EXT_STATE.FLY_LEAVING ||
      flightState === EXT_STATE.PARTNERSHIP;
    const showFlightButton = showCamera && !placed; // tu condición actual
    const flightButtonVisible = showFlightButton && canShowFlightButton; //TODO: usar una flahg sola

    return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      {isDesktop && <LandingDesktopQR qrImageSrc="../images/components/LandingDesktopQR/qr-dummy.png" />}
      
      {!showExperience && (
        <>
          <OverlayScreen
              open={open}
              onClose={() => setOpen(false)}
              className={shouldFadeOut ? "overlay--fade-out" : ""}
              progress={!isComplete ? progress : undefined}
          />
          <LandingPageExt 
            onEnterExperience={handleEnterExperience} 
            shouldFadeIn={shouldFadeIn}
          />
        </>
        )}

          {showCamera && (
            <div
              style={{
                opacity: flightButtonVisible ? 1 : 0,
                pointerEvents: flightButtonVisible ? "auto" : "none",
                transition: "opacity 250ms ease",
              }}
            >
              <FlightButton
                initialState={EXT_STATE.NOT_STARTED}
                state={flightState}
                onSetState={setFlightState}
                // initialState="land"
                travelInfo={{
                  origin: "San Francisco",
                  destination: "San Jose",
                  city: "San Francisco",
                  travelCarTime: "1 h 25 m",
                  travelJobyTime: "16 m",
                }}
                onClick={handleFlightButtonClick}
                shouldAnimate={flightButtonVisible} // si tu anim depende de esto
              />
            </div>
          )}
      
      
      {showExperience && (
        <>
        <VisitSiteButton align="right" />
          {showCamera && <CameraBackground experienceType="ext" />}
          {showCamera && <ExteriorSceneThreeJS 
            onLoaded={setIsSceneLoaded}
            playing={playing} 
            heliRef={heliRef} 
            onReady={() => setHeliReady(true)}
            flightState={flightState}
            hidden={placed} 
            advanceFlightState={advanceFlightState}
          />}
          <TapToPlace placed={placed && isSceneLoaded} onPlace={handleSetPlace} />
        </>
      )}

    </div>)
}